<template>
  <div class="nav-header bg-transparent shadow-none border-0">
    <div class="nav-top w-100">
      <router-link to="/" class="d-flex align-items-center text-decoration-none">
        <img :src="require('@/assets/images/logo.webp')" alt="SNEXUS" style="height: 60px;">
        <span class="d-inline-block fredoka-font ls-3 fw-600 text-current font-xxl logo-text mb-0 ms-2">
          SNEXUS
        </span>
      </router-link>

      <div class="ms-auto d-flex align-items-center">
        <router-link
          :to="{ name: 'login' }"
          class="header-btn d-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl"
        >
          Login
        </router-link>
        <router-link
          :to="{ name: 'register' }"
          class="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl"
        >
          Register
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
// minimal, uses global vendor CSS from public/index.html
</script>
